// extracted by mini-css-extract-plugin
export var fullHeightState = "_1r-7";
export var headerCell = "_1r-1";
export var loadingStateCell = "_1r-4";
export var rowWrapper = "_1r-3";
export var standaloneTable = "_1r-8";
export var standaloneTableWithBodyFill = "_1r-9";
export var stateCell = "_1r-5";
export var table = "_1r-0";
export var tableBodyFiller = "_1r-6";
export var white = "_1r-2";